import Link from "next/link";
import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaTiktok,
  FaYoutube,
} from "react-icons/fa";
import LogoLink from "./LogoLink";

const Footer = () => {
  return (
    <footer className="bg-gray-100 p-5">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row justify-between items-center">
        <div className="flex flex-col lg:flex-row items-center mb-4 lg:mb-0">
          <LogoLink />
          <p className="text-gray-600 text-sm mb-4 lg:mb-0"></p>
        </div>
        <div className="flex flex-col lg:flex-row items-center md:flex-row">
          <div className="text-gray-800 mb-4 lg:mb-0 lg:mr-10 flex flex-col md:justify-normal justify-center w-full text-center">
            <Link
              href="mailto:info@eyam.finance"
              className="hover:text-blue-500 transition-colors"
            >
              info@eyam.finance
            </Link>
            <Link
              href="tel:+27872652055"
              className="hover:text-blue-500 transition-colors"
            >
              +27 87 265 2055
            </Link>
            <p className="w-full">
              The Boulders, Sunningdale Avenue, Sunnyridge, East London, 5201
            </p>
          </div>

          <div className="flex space-x-4">
            <a
              href="https://www.facebook.com/profile.php?id=61572843957629"
              className="text-blue-600 hover:text-blue-800 transition-colors"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://youtube.com/@eyamfinance?si=LlT1rfWw6O8isiLX"
              className="text-blue-300 hover:text-blue-500 transition-colors"
            >
              <FaYoutube />
            </a>
            <a
              href="https://www.instagram.com/eyam_finance?igsh=YzljYTk1ODg3Zg=="
              className="text-pink-600 hover:text-pink-800 transition-colors"
            >
              <FaInstagram />
            </a>
            <a
              href="https://vm.tiktok.com/ZSMtop1Ta/"
              className="text-blue-700 hover:text-blue-900 transition-colors"
            >
              <FaTiktok />
            </a>
          </div>
        </div>
      </div>
      <div className="text-center text-sm text-gray-600 mt-5">
        <nav aria-label="Business listing resources" className="mb-4 flex flex-wrap justify-center gap-x-5 gap-y-2">
          <Link href="/list-your-business" className="underline underline-offset-4">List your business</Link>
          <Link href="/business-listing-pricing" className="underline underline-offset-4">Listing plans</Link>
          <Link href="/list-your-services-online-south-africa" className="underline underline-offset-4">Listing guide</Link>
          <Link href="/website-alternatives-for-small-businesses" className="underline underline-offset-4">Website alternatives</Link>
        </nav>
        © 2026 Eyam. All rights reserved |{" "}
        <Link
          className="hover:text-blue-500 transition-colors"
          href={"/termsandconditions"}
        >
          Terms & Conditions
        </Link>{" "}
        |{" "}
        <Link
          href="/PrivacyPolicy"
          className="hover:text-blue-500 transition-colors"
        >
          Privacy Policy
        </Link>
      </div>
      <div className="text-center text-sm text-gray-600 mt-2">
        <a
          href="https://exceedit.tech/"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-blue-500 transition-colors"
        >
          Custom Software Development by Exceed IT
        </a>
      </div>
    </footer>
  );
};

export default Footer;
